import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-core-detail-changes',
    templateUrl: './core-detail-changes.component.html',
    styleUrls: ['./core-detail-changes.component.scss'],
    standalone: false
})
export class CoreDetailChangesComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
